import { DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import PropTypes from "prop-types";
import { Button } from "../Button";
import { DialogContainer, DialogBox } from "../BalanceWarning/styles";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

export const ConfirmDialogModal = ({
  text,
  open,
  onClose,
  refreshAction,
  description,
}) => {
  return (
    <div>
      <DialogContainer open={open} keepMounted onClose={onClose} style={{ zIndex: 2000 }}>
        <DialogTitle>{text}</DialogTitle>
        <DialogBox>
          <DialogContentText id="alert-dialog-slide-description" sx={{ padding: "20px", whiteSpace: "pre-line", color: "text.primary" }}>
            {description}
          </DialogContentText>
        </DialogBox>
        <DialogActions>
          <Button action={"cancel"} onClick={onClose}>
            <CloseIcon sx={{ fontSize: 30 }} />
            Cancelar
          </Button>
          <Button action={"success"} onClick={() => refreshAction(true)}>
            <CheckIcon sx={{ fontSize: 30 }} />
            <strong>Confirmar</strong>
          </Button>
        </DialogActions>
      </DialogContainer>
    </div>
  );
};

ConfirmDialogModal.propTypes = {
  text: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refreshAction: PropTypes.func,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

ConfirmDialogModal.defaultProps = {
  refreshAction: () => {},
  description: null,
};
